import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track, trackSectionOnce } from "@/lib/analytics";

export function PageViewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    track("page_view", { referrer: document.referrer || "direct" }, pathname);
  }, [pathname]);
  return null;
}

export function useSectionTracking(enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const sections = document.querySelectorAll("main section[id]");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) trackSectionOnce(e.target.id);
        });
      },
      { threshold: 0.35 }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, [enabled]);
}
